import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PageLimitModule } from '@psei/ng/page-limit';
import { PaginationModule } from '@psei/ng/pagination';
import { PseicTableComponent } from './pseic-table.component';

@NgModule({
  declarations: [PseicTableComponent],
  imports: [
    CommonModule,
    PageLimitModule,
    PaginationModule,
    FlexLayoutModule
  ],
  exports: [PseicTableComponent]
})
export class PseicTableModule { }
